import { ACTIONS } from "./../constants"


const initialState = { 
  establishments: [], 
  establishment: {}, 
  totalSize: 0,
  isFetching: false, 
  isLoading: false,
  hasMore: true, 
  success: false,
  error: null
}


export default (state = initialState , action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_ESTABLISHMENT : {
      return { ...state, success: false, error: null, isFetching: false, isLoading: false }
    }

    case ACTIONS.FETCH_ESTABLISHMENTS_INIT : {
      return { ...state, isFetching: true, success: false, error: null }
    }
    case ACTIONS.FETCH_ESTABLISHMENTS_SUCCEDED : {
      const { count, results } = payload
      return { ...state, totalSize: count, establishments: results, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_ESTABLISHMENTS_FAILED : {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.CREATE_ESTABLISHMENT_INIT : {
      return { ...state, isLoading: true, error: null, success: false }
    }
    case ACTIONS.CREATE_ESTABLISHMENT_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_ESTABLISHMENT_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }

    case ACTIONS.EDIT_ESTABLISHMENT_INIT : {      
      return { ...state, isLoading: true, error: null, success:false }
    }
    case ACTIONS.EDIT_ESTABLISHMENT_SUCCEDED : {
      return { ...state, establishment: payload, success: true, isLoading: false, error: null }
    }
    case ACTIONS.EDIT_ESTABLISHMENT_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }
 
    case ACTIONS.FETCH_ESTABLISHMENT_INIT : {
      return { ...state, isLoading: true, establishment: null, error: null }
    }
    case ACTIONS.FETCH_ESTABLISHMENT_SUCCEDED : {
      return { ...state, establishment: payload, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_ESTABLISHMENT_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DISABLE_ESTABLISHMENT_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.DISABLE_ESTABLISHMENT_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.DISABLE_ESTABLISHMENT_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.ENABLE_ESTABLISHMENT_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.ENABLE_ESTABLISHMENT_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.ENABLE_ESTABLISHMENT_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DISABLE_ESTABLISHMENTS_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.DISABLE_ESTABLISHMENTS_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.DISABLE_ESTABLISHMENTS_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.ENABLE_ESTABLISHMENTS_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.ENABLE_ESTABLISHMENTS_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.ENABLE_ESTABLISHMENTS_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    default: {
      return state
    }
  }
}
